import React from 'react';


import { useTypedTranslation } from '@app/hooks';
import { Link } from '@material-ui/core';

interface IProps {
    onClose: Function;
}

const ContactAdmin = (props: IProps) => {
    const { translation } = useTypedTranslation();
    return (
        <>
            <div className='rowcontainer'>
                <div className='dirsync__agent'>
                    <img src='/assets/images/directorysync/01-dirsync.png'></img>
                    <div className='dirsync__agent--content'>
                        <h2>{translation('DIRSYNC_CONTACTADMIN_TITLE')}</h2>
                        <p>{translation('DIRSYNC_CONTACTADMIN_TEXT')}</p>
                        <p>{translation('DIRSYNC_CONTACTADMIN_TEXT2')}</p>
                        <Link
                            className='getstarted_button'
                            component='button'
                            onClick={() => props.onClose()}
                        >
                            {translation('DIRSYNC_CANCEL')}
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactAdmin;